import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { Users } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const LiveVisitors = () => {
  const [visitorCount, setVisitorCount] = useState(1); // Default to at least 1 (the current user)

  useEffect(() => {
    // Connect to the backend
    const socket = io(BACKEND_URL, {
      reconnectionDelayMax: 10000,
      transports: ['websocket', 'polling']
    });
    
    // Get the current subdomain/hostname to track visitors per subdomain
    const subdomain = window.location.hostname;

    socket.on('connect', () => {
      // Let the backend know which subdomain this user is visiting
      socket.emit('register-visitor', { subdomain });
    });

    // Listen for visitor count updates from the server
    socket.on('visitor-count-update', (data) => {
      // The backend should send the count for this specific subdomain
      // Format expected: { subdomain: 'example.com', count: 42 }
      if (data.subdomain === subdomain) {
        setVisitorCount(data.count);
      }
    });

    // Cleanup on unmount (e.g. tab closed)
    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <div className="fixed bottom-4 left-4 z-[100] flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 text-white px-4 py-2.5 rounded-full shadow-[0_4px_30px_rgba(0,0,0,0.1)] transition-all duration-300 hover:bg-white/20 hover:scale-105 group">
      <div className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75 animate-ping"></span>
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
      </div>
      <Users className="w-4 h-4 text-gray-200 group-hover:text-white transition-colors" />
      <span className="text-sm font-medium tracking-wide">
        <span className="font-bold text-green-400">{visitorCount}</span> Live {visitorCount === 1 ? 'Visitor' : 'Visitors'}
      </span>
    </div>
  );
};

export default LiveVisitors;
